export default __webpack_public_path__ + "static/media/Gauntlets of Reckless Challenge.98ab5d79.jpg";